export const paths = {
  home: () => '/',
  addClient: () => '/add-client',
  clientProfile: (clientId: string) => `/client-profile/${clientId}`,
  clientProfilePattern: '/client-profile/:clientId',
  clientHistory: (clientId: string) => `/client-profile/${clientId}/history`,
  clientHistoryPattern: '/client-profile/:clientId/history',
  clientPastPasses: (clientId: string) => `/client-profile/${clientId}/past-passes`,
  clientPastPassesPattern: '/client-profile/:clientId/past-passes',
  passEditor: () => '/pass-editor',
  profile: () => '/profile',
} as const;

export interface ClientProfileLocationState {
  openAddPass?: boolean;
  createdTemplate?: import('@/types').PassType;
}

export interface ClientHistoryLocationState {
  focusSearch?: boolean;
}

export interface PassEditorLocationState {
  openModal?: boolean;
  returnTo?: string;
}

export interface AddClientLocationState {
  createdTemplate?: import('@/types').PassType;
}
